import * as React from "react";
import { Chart } from "react-google-charts";
import { Label } from 'office-ui-fabric-react/lib/Label';

/* https://www.npmjs.com/package/react-google-charts */

var _data = [];

export class GoogleChart extends React.Component  {
    
    constructor(props)
    {
        super(props);
        
        this.state = {
            titolo : 'Registri Energia Attiva',
            width : '100%',
            height : '400px',
            chartType : 'ColumnChart',
            opzioni : {legend: 'bottom'}
        }
        
        if( 'dati' in props){ _data = props.dati; }
        if( 'titolo' in props){ this.setState({titolo : props.titolo }); }
        if( 'opzioni' in props){ this.setState({opzioni : props.opzioni }); }
        if( 'width' in props){ this.setState({width : props.width }); }
        if( 'height' in props){ this.setState({height : props.height }); }
        if( 'type' in props){ 
            if( props.type === 'ColumnChart'){ this.setState({chartType : 'ColumnChart' }); }
            if( props.type === 'LineChart'){ this.setState({chartType : 'LineChart' }); }
        }
        
    }
    
    render() {
        
        
        if( _data.length > 1 && _data[0].length > 1 )
        {
            return (
                <span>
                    <Label className='ms-fontSize-xl'>{this.state.titolo}</Label>
                    <Chart    
                        chartType={this.state.chartType}
                        width={ this.state.width }
                        height={ this.state.height }
                        data={ _data }
                        options={this.state.opzioni}
                    />
                </span>
            );      
        }
        else
        {
            return (
                <span className='margin5'>
                    <Label className='ms-fontSize-m warning centrato'>Non sono stati selezionati i dati corretti per visualizzare il grafico</Label>
                </span>
            ); 
        }
    }  

};
export default GoogleChart;


// WEBPACK FOOTER //
// ./src/AcComponents/classi/GoogleChart.js